const Ajax = require('./ajax');

const MacrosFront = {
    loaded: false,
    _active: function () {
        if (this.loaded) {
            return;
        }
        this.loaded = true;
        this._user_country = document.querySelectorAll('*[data-user-country]');
        return this._user_country.length;
    },
    init: function () {
        let self = this;
        if (!self._active()) {
            return false;
        }

        Ajax.get(ajaxurl + '?action=get_user_country', function (response) {
            self._user_country.forEach(function (item) {
                item.innerHTML = response;
            });
        });
    },
};

module.exports = MacrosFront;
